
export class JManError extends Error {
	constructor (opts) {
		super (opts);
		this.name = "JMan Error";

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManError
		this.__proto__   = JManError.prototype
	}
};

export class JManErrorDatabaseNotReady extends JManError {
	constructor (opts) {
		super (opts);
		this.message = this.message || "Database not ready";

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManErrorDatabaseNotReady
		this.__proto__   = JManErrorDatabaseNotReady.prototype
	}
};

export class JManErrorLoginRequired extends JManError {
	constructor (opts) {
		super (opts);
		this.message = this.message || "Login required";

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManErrorLoginRequired
		this.__proto__   = JManErrorLoginRequired.prototype
	}
};

export class JManErrorLoginFailed extends JManError {
	constructor (opts) {
		super (opts);
		this.message = this.message || "Login failed";

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManErrorLoginFailed
		this.__proto__   = JManErrorLoginFailed.prototype

	}
};

export class JManErrorNetworkError extends JManError {
	constructor (opts) {
		super (opts);
		this.message = this.message || "Network error";

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManErrorNetworkError
		this.__proto__   = JManErrorNetworkError.prototype
	}
};

export class JManErrorServerError extends JManError {
	constructor (body, opts) {
		super (opts);
		for (let key in body) {
			this[key] = body[key];
		}

		// Work around for stupid Babel bug
		// https://github.com/babel/babel/issues/4485
		this.constructor = JManErrorServerError
		this.__proto__   = JManErrorServerError.prototype
	}
};




// WEBPACK FOOTER //
// ./src/assets/js/JMan/JManError.js